import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/system`
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

export const urlUfs = `${BASE_URL}/ufs`

export const urlCities = uf_id => `${BASE_URL}/cities/${uf_id}`

export const urlMassiveClientsInserts = (file_type_id, tpId, associarAoTp) =>
  `${BASE_URL}/massive-client-insert/${file_type_id}?tp_id=${tpId}&associate_to_tp=${associarAoTp}`

export const urlMassiveProductsInserts = `${BASE_URL}/massive-product-insert`

export const urlMassiveDriversInserts = `${BASE_URL}/massive-driver-insert`

export const urlMassiveVehiclesInserts = `${BASE_URL}/massive-vehicle-insert`

export const urlMassiveClientsRoutesInserts = tp_id =>
  `${BASE_URL}//massive-rota-cliente-insert/${tp_id}`

export const urlMassiveProductsEanInserts = `${BASE_URL}/massive-product-ean-insert`

export const urlMassiveClientStepInserts = `${BASE_URL}/massive-client-step-insert`

export const urlMassiveAssocClientCompany = `${BASE_URL}/massive-assoc-client-company`

export const urlPostNovoCelular = `${BASE_URL}/app-expedicao/celular`

export const urlGetCelulares = tp_id => `${BASE_URL}/app-expedicao/celulares/${tp_id}`

export const urlGetCelularesByEmail = (tp_id, email) =>
  `${BASE_URL}/app-expedicao/celulares-by-email/${tp_id}/${email}`

export const urlGetUsuariosCelularAppExpedicao = celular_id =>
  `${BASE_URL}/app-expedicao/usuarios/${celular_id}`

export const urlToggleUsuarioAutorizado = `${BASE_URL}/app-expedicao/toggle-usuario-autorizado`

export const urlToggleUsuarioFinalizaPicking = `${BASE_URL}/app-expedicao/toggle-usuario-finaliza-picking`

export const urlToggleUsuarioConfiguraPicking = `${BASE_URL}/app-expedicao/toggle-usuario-configura-picking`

export const urlToggleUsuarioConfiguraReconferenciaEtiqueta = `${BASE_URL}/app-expedicao/toggle-usuario-configura-reconferencia-etiqueta`

export const urlGetUsuariosByCelularesAppExpedicao = `${BASE_URL}/app-expedicao/usuarios-by-celulares`

export const urlAssociacaoMassaConfigsAppExpedicao = `${BASE_URL}/app-expedicao/associacao-massa-configs`

// Celular Tp Drive
export const urlPutCelularTpDrive = `${BASE_URL}/app-tp-drive/celular`

export const urlGetCelularesTpDrive = tp_id => `${BASE_URL}/app-tp-drive/celulares/${tp_id}`

export const urlToggleUsuarioAutorizadoTpDrive = `${BASE_URL}/app-tp-drive/toggle-usuario-autorizado`

export const urlDesassociarUsuarioTpDrive = associacao_id =>
  `${BASE_URL}/app-tp-drive/desassociar-usuario/${associacao_id}`

// ***** User Action Group *****
export const urlUserActionGroup = `${BASE_URL}/user-action-groups`

// ***** User Action *****
export const urlUserAction = `${BASE_URL}/user-action`

export const urlGetUsersActions = `${BASE_URL}/user-actions`

// CNPJs Secundários (por empresa) - via system middleware
export function urlSystemCompanyCnpjs(companyId) {
  return `${BASE_URL}/company/${companyId}/cnpjs`
}
export function urlSystemPostCompanyCnpj(companyId) {
  return `${BASE_URL}/company/${companyId}/cnpj`
}
export function urlSystemDeleteCompanyCnpj(id) {
  return `${BASE_URL}/company/cnpj/${id}`
}

// ***** User Group Permission *****
export const urlGetPermissions = group_id =>
  `${BASE_URL}/associacao-user-group-permissions/${group_id}`

export const urlToggleGroupPermissions = (group_id, user_action_id) => {
  return `${BASE_URL}/associar-user-group-permissions/${group_id}/${user_action_id}`
}

// ***** Tipos de Arquivos de Importação de Entrega *****

export const urlGetTiposArquivos = `${BASE_URL}/tipos-arquivo-importacao`

export const urlGetTiposArquivosByIds = ids => `${BASE_URL}/tipos-arquivo-importacao-ids?ids=${ids}`

export const urlPostTipoArquivo = `${BASE_URL}/tipo-arquivo-importacao`

export const urlUploadModeloImportacao = (tipoId, name) =>
  `${DOC_BASE_URL}/modelo-importacao/${tipoId}?name=${encodeURIComponent(name)}`

export const urlModeloImportacao = filename =>
  `${DOC_BASE_URL}/modelo-importacao/${encodeURIComponent(filename)}`

export const urlGetTiposArquivoPorEmpresa = company_id =>
  `${BASE_URL}/tipos-arquivo-importacao/${company_id}`

export const urlPutHandleAssocTiposArquivoEmpresa = `${BASE_URL}/handle-tipo-arquivo-empresa`

// ****** Gerar Arquivo de Separação - Emergencial ***** //

export const urlPickingsProntosParaDownload = tp_id =>
  `${BASE_URL}/get-pickings-para-download/${tp_id}`

export const buildUrlParaDownloadArquivoDeSeparacao = (tp_id, picking_id, equipe_id) => {
  return `${BASE_URL}/download-arquivo-de-separacao/${tp_id}/${picking_id}/${equipe_id}?t=${localStorage.getItem('t')}`
}

// ****** Companies Group ***** //

export const urlSaveAssocCompanyGroup = `${BASE_URL}/companies-group/save-assoc`

export const urlGetCompaniesGroupsWithItems = `${BASE_URL}/companies-group/`

export const urlGetCompaniesToAssocWithGroup = `${BASE_URL}/companies-group/items-to-assoc`

export const urlCreateCompanyGroup = `${BASE_URL}/companies-group/create`

export const urlUpdateCompanyGroup = `${BASE_URL}/companies-group/update`

export const urlDeleteCompanyGroup = company_group_id =>
  `${BASE_URL}/companies-group/delete/${company_group_id}`

export const urlGetCompaniesGroupAssociatedToUser = userId =>
  `${BASE_URL}/companies-group/from-user/${userId}`

export const urlAssocCompaniesGroupToUser = userId => `${BASE_URL}/companies-group/assoc/${userId}`

export const urlGetCompaniesByUserId = userId => `${BASE_URL}/companies/user/${userId}`

// ****** Clients Inconsistency ***** //

export const urlGetClientsWithIncosistency = () => `${BASE_URL}/clients-inconsistency`
export const urlGetClientsWithIncosistencyDelete = clientId =>
  `${BASE_URL}/clients-inconsistency/delete/${clientId}`

export const urlGetCoordinates = endereco =>
  `${BASE_URL}/coordinates?endereco=${encodeURIComponent(endereco)}`

export const urlGetCnpjDataFocusNfe = cnpj => `${BASE_URL}/cnpj/${cnpj}`

export const urlMissingReasonStandard = `${BASE_URL}/missing-reason-standard`

export function urlReportUtilizacaoSistema(pInicial, pFinal, userId) {
  return `${BASE_URL}/report-utilizacao-sistema/${userId}?pInicial=${pInicial}&pFinal=${pFinal}&t=${localStorage.getItem('t')}`
}

export function urlChangeStatusPickingToProntoParaDownload(pickingId, userId) {
  return `${BASE_URL}/picking-to-pronto-para-download/${pickingId}?user_id=${userId}`
}

export function urlOperationCentersCyclesByCompany(companyId, pInicial, pFinal) {
  return `${BASE_URL}/operationcenters-cycles-by-company/${companyId}?pInicial=${pInicial}&pFinal=${pFinal}`
}

export function urlSaldoMovimentacoesSaldoEstoque(tpId, companyId, productId, estoquesIds) {
  const estoques = Array.isArray(estoquesIds) ? estoquesIds.join(',') : String(estoquesIds || '')
  return (
    `${BASE_URL}/saldo-movimentacoes-saldo-estoque/${tpId}` +
    `?company_id=${companyId}` +
    `&product_id=${productId}` +
    `&estoques_ids=${encodeURIComponent(estoques)}`
  )
}

export function urlCriarMovimentacaoSaldoMovimentacoesSaldoEstoque(tpId) {
  return `${BASE_URL}/saldo-movimentacoes-saldo-estoque/${tpId}/criar-movimentacao`
}
